import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    selector: 'p-field-edit',
    styleUrls: ['./p-field-edit.component.scss'],
    template: `
        <p-field
            [isMandatory]="isMandatory"
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="isReadOnly"
            [isDisable]="isDisabled"
            [customClasses]="customClasses"
        >
            <div slot="readMode">
                <div class="p-input-text p-paragraph-1" floatLabel="always">
                    <div fxFlex fxLayout="row" class="text-format" [matTooltip]="value ?? ''" style="display: flex">
                        <div class="mat-mdc-form-field-infix text-format">
                            {{ value }}
                        </div>
                        <ng-content select="[slot=readMode]" fxFlex="20"></ng-content>
                    </div>
                </div>
            </div>
            <div slot="editMode">
                <div class="p-input-text p-paragraph-1" floatLabel="always">
                    <div style="display: flex" class="text-format" [matTooltip]="value ?? ''">
                        <input [readonly]="true" class="text-format" matInput fxFlex type="text" [value]="value" />
                        <ng-content select="[slot=editMode]" fxFlex="20"></ng-content>
                        <p-icon name="edit" class="transaction-icon" (click)="edit()"></p-icon>
                    </div>
                </div>
            </div>
        </p-field>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldEditComponent
        }
    ]
})
export class PFieldEditComponent extends PFieldAbstractComponent<string> {
    @Input() label?: string;
    @Input() isMandatory = false;
    @Input() override isReadOnly = false;
    @Input() customClasses?: string;
    @Input() override isDisabled = false; // todo + move to all p[field directory

    @Output() editClicked = new EventEmitter<void>();

    constructor(protected override readonly cd: ChangeDetectorRef) {
        super(cd);
    }

    edit() {
        this.editClicked.emit();
    }
}
